export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";

export const LOAD_SYSTEM_RESOURCES = "LOAD_SYSTEM_RESOURCES";

export const RETRIEVE_LOAD_USER_INFO = "LOAD_USER_INFO"; // retrieve from DB, load to redux store
export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS"; // update user setting once retrieve from the database
export const WRITE_USER_SETTINGS_TO_DB = "WRITE_USER_SETTINGS"; // update the current user information to the database by http request
export const DESTROY_USER_SETTINGS = "DESTROY_USER_SETTINGS"; // when user log off, remove the user info from store and set to default
export const CHANGE_LANGUAGE_TEMP = "CHANGE_LANGUAGE_TEMP"; // temp change language
export const WRITE_LANGUAGE_TO_db = "WRITE_LANGUAGE_TO_db"; // change the default language and write to the database

export const SELL_AVATAR = "SELL_AVATAR"; // sell avatar and gain coins
export const UPDATE_USER_RECORDS = "UPDATE_USER_RECORDS" //update user records from http request

export const CHANGE_SYSTEM_RESOURCES = "CHANGE_SYSTEM_RESOURCES";
